export default class Config {
    static CO_NAME = "Älem Tilsimat";
    static APP_NAME = "Alem Kassa";
    static VERSION = "3.1.6";
    
    static IS_DEV = false;
    static URL_SERVER = this.IS_DEV ? 'http://127.0.0.1:4000' : window.location.origin;
    static PATH_PREFIX = this.IS_DEV ? "/static" : "/api/static";
    static PATH_PRODUCT_IMAGES = "/images/products/";
    static PATH_COUNTRY_FLAGS = "/images/flags/";
    static PATH_BACKUP_SQL = "/backup/";
}